import boxx from '@baidu/boxx-fe';
import {isPcClient} from '@lib/utils/env';
import __INSTANCE__ from '../InstanceManager';
import {inNewApp} from './tools';

/**
 * @description 反注册数据通道
 * @description 端能力文档 http://es.baidu-int.com/#/apidetail/588
 * @description demo schema baiduboxapp://datachannel/unregister?action=com.baidu.newapp.na.test_browser&page=dataChannelDemoWeb&callback=__boxx_4
 * @param action 反注册的数据通道的名称，对应于注册时的名称。例如，'com.baidu.newapp.na.chat_send'，见 https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/pKzJfZczuc/2bDtTCu3yf/oBHlk4LR3uEvhf
 * @param page 页面的名称，默认为'newappmain'
 */
const unRegisterDataChannel = (action: string, page = 'newappmain') => {
    if (boxx.canIUse('event.off')) {
        boxx.event.off({
            action,
            page: `wb${window.webviewId}_${page}`,
            // debug时可以解开注释，success为调用端能力成功回调，fail为调用端能力失败回调
            // success: res => {
            //     console.log(res);
            // },
            // fail: res => {
            //     console.log(res);
            // },
        });
    }
    else {
        // console.error('event.off 端能力不存在！！！');
        // __INSTANCE__.emitter.removeListener(action, (emitter as any)._evnents[action]);
    }
};

/**
 * @description 注册数据通道
 * @description 端能力文档 http://es.baidu-int.com/#/apidetail/559
 * @description demo schema baiduboxapp://datachannel/register?action=com.baidu.newapp.na.test_browser&jscallback=__boxx_event_1&callback=__boxx_1
 * @param action 数据通道的名称，例如，'com.baidu.newapp.na.chat_send'，见 https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/pKzJfZczuc/2bDtTCu3yf/oBHlk4LR3uEvhf
 * @param jscallback jscallback会在event.emit执行时调用，即na发消息时被调用
 * 如果类型是funcion则会被boxx包装后挂载在window.__boxx_event_x，如果类型是string，则需要手动挂载在window上，window.xxx = (action, data) => {}
 * @param unRegFirst 默认true
 * @param page 页面的名称，默认为'newappmain'
 */
const registerDataChannel = <T>(action: string,
    jscallback: (action: string, data: T) => void | string,
    unRegFirst = true,
    page = 'newappmain') => {
    if (boxx.canIUse('event.on')) {
        if (unRegFirst) {
            unRegisterDataChannel(action, page);
        }
        boxx.event.on({
            action,
            page: `wb${window.webviewId}_${page}`,
            jscallback,
            // debug时可以解开注释，success为调用端能力成功回调，fail为调用端能力失败回调
            // success: (res: any) => {
            //     console.log('success', res);
            // },
            // fail: (res: any) => {
            //     console.log('fail', res);
            // },
        });
    }
    else {
        // console.error('event.on 端能力不存在！！！');
        if (!inNewApp || isPcClient()) {
            __INSTANCE__.emitter?.on(action, jscallback);
        }
    }
};

/**
 * @description 发送广播
 * @description 端能力文档 http://es.baidu-int.com/#/apidetail/590
 * @description demo schema baiduboxapp://datachannel/sendbroadcast?action=com.baidu.newapp.h5.test_browser&data=6&callback=__boxx_2
 * @param action 发送广播的名称，NA侧会对该action进行监听，收取h5发送的数据，例如'com.baidu.newapp.h5.chat_send'，见 https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/pKzJfZczuc/2bDtTCu3yf/oBHlk4LR3uEvhf
 * @param payload 传输的数据
 */
const sendbroadcast = <T>(action: string, payload: T) => {
    if (boxx.canIUse('event.emit')) {
        const data =  JSON.stringify(Object.assign({}, payload, {
            webviewId: window.webviewId,
        }));
        boxx.event.emit({
            action,
            data,
            // debug时可以解开注释，success为调用端能力成功回调，fail为调用端能力失败回调
            // success: res => {
            //     console.log(res);
            // },
            // fail: res => {
            //     console.log(res);
            // },
        });
    }
    else {
        // console.error('event.emit 端能力不存在！！！');
        // pc、小程序下
        if (!inNewApp || isPcClient()) {
            __INSTANCE__.emitter?.emit(action, payload);
        }
    }
};

export {
    registerDataChannel,
    sendbroadcast,
    unRegisterDataChannel,
};
